var map = {
	"./en/changePassword.json": "./translations/en/changePassword.json",
	"./en/common.json": "./translations/en/common.json",
	"./en/errors.json": "./translations/en/errors.json",
	"./en/forgotPassword.json": "./translations/en/forgotPassword.json",
	"./en/game.json": "./translations/en/game.json",
	"./en/login.json": "./translations/en/login.json",
	"./en/register.json": "./translations/en/register.json",
	"./en/subreddit.json": "./translations/en/subreddit.json",
	"./en/upload.json": "./translations/en/upload.json",
	"./en/userportal.json": "./translations/en/userportal.json",
	"./en/verify.json": "./translations/en/verify.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./translations recursive \\.json";


//////////////////
// WEBPACK FOOTER
// ./translations \.json
// module id = ./translations recursive \.json
// module chunks = 1